import { Box, Snackbar, Alert } from "@mui/material";
import { colors, spacing } from "../../../../assets/styles/tokens";
import { useLeadsManagementData } from "../hooks/useLeadsManagementData";
import LeadsMobile from "./LeadsMobile";
import LeadsManagementMobileTabs from "./LeadsManagementMobileTabs";
import AnalyticsMobile from "./AnalyticsMobile";
import MobileFloatingActionButton from "../../../../pages/FloatingItems/MobileFloatingActionButton";

interface LeadsManagementMobileProps {
  websiteSharedUid: string;
}

// Mirrors LeadsManagement.tsx's data flow (one useLeadsManagementData call
// feeding every child) — only the page chrome and the Leads/Analytics tabs'
// content differ for mobile. The hamburger/search app bar is already
// supplied globally by MobileDrawer (via WorkspaceLayout), so this doesn't
// render one of its own.
export default function LeadsManagementMobile({ websiteSharedUid }: LeadsManagementMobileProps) {
  const leadsData = useLeadsManagementData(websiteSharedUid);

  return (
    <Box sx={{ backgroundColor: colors.Base.White.$value, minHeight: "100%" }}>
      <LeadsManagementMobileTabs view={leadsData.view} onChangeView={leadsData.setView} />

      {leadsData.view === "leads" ? (
        <LeadsMobile data={leadsData} />
      ) : (
        <Box sx={{ px: spacing.Spacing.xl.$value }}>
          <AnalyticsMobile data={leadsData} />
        </Box>
      )}

      <MobileFloatingActionButton />

      <Snackbar
        open={!!leadsData.toastMessage}
        autoHideDuration={3400}
        onClose={leadsData.clearToast}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
      >
        <Alert severity={leadsData.toastSeverity} onClose={leadsData.clearToast} sx={{ width: "100%" }}>
          {leadsData.toastMessage}
        </Alert>
      </Snackbar>
    </Box>
  );
}
